import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag-2, luggage, buggage "><path d="M2.75 20.25H21.25V7.75H2.75V20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.00391 20.25V3.75H16.0039V20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBag2;
